<template>
    <section class="contact-wrapper">
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <article class="contact-top">
            <span class="top-span1">{{$t("Home.Contact.span1")}}</span>
            <span class="top-span2">{{$t("Home.Contact.span2")}}</span>
        </article>
        <v-card elevation="5" class="contact-section">
            <v-form class="contact-form" v-model="isFormValid">
                <span class="form-span1">{{$t("Home.Contact.span3")}}</span>
                <v-text-field :rules="emailRules" v-model="clientEmail" outlined label="E-Mail"></v-text-field>
                <v-textarea rows="2" v-model="clientMess" outlined :label="$t('Home.Contact.mess')"></v-textarea>
                <v-checkbox v-model="checkbox"
                    :label="$t('Home.Contact.checkbox')">
                </v-checkbox>
                <v-btn class="form-btn" :disabled="!checkbox" color="#10424b" width="200" large outlined @click="sendEmail()">WYŚLIJ</v-btn>
            </v-form>
            <v-card-actions class="contact-info">
                <span class="info-span1">{{$t("Home.Contact.info")}}</span>
                <div class="sections">
                    <div class="section">
                        <v-icon class="right-icon" color="white">mdi-email-outline</v-icon>
                        <span><a target="_blank" href="mailto:robert.bak@cssas.company">robert.bak@cssas.company</a></span>
                    </div>
                    <div class="section">
                        <v-icon class="right-icon" color="white">mdi-phone-outline</v-icon>
                        <span><a href="tel:123456789">(+48) 724 258 152</a></span>
                    </div>
                    <div class="section">
                        <v-icon class="right-icon" color="white">mdi-map-marker-outline</v-icon>
                        <span><a target="_blank" href="https://www.google.pl/maps/place/Vatnefjordvegen+12,+6265+Vatne,+Norwegia/@62.5596854,6.6136887,17z/data=!3m1!4b1!4m5!3m4!1s0x4616b61c14388637:0xf3e82eba10312a81!8m2!3d62.5596829!4d6.6158774">{{$t("Home.Contact.info_add")}}</a></span>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
        <v-snackbar outlined elevation="5" color="#10424b" v-model="snackbar" :timeout="snackTimeout">
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    Zamknij
                </v-btn>
            </template>
        </v-snackbar>
    </section>
</template>

<script>
export default {
    name: 'home-contact',
    data () {
        return {
            snackbar: false,
            snackText: '',
            snackTimeout: 2000,
            checkbox: false,
            clientEmail: '',
            clientMess: '',
            loading: false,
            emailRules: [
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail jest nieprawidłowy.'
            ],
        }
    },
    methods: {
        sendEmail() {
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.clientEmail)) {
                this.loading = true;
                this.loading = false;
                this.snackbar = true;
                this.snackText = 'Poprawnie wysłano wiadomość';
            } else {
                this.snackbar = true;
                this.snackText = 'E-mail jest nieprawidłowy.';
            }
        }
    }
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.contact-wrapper {
    width: 100%;
    height: auto;
    padding: 50px;
    display: flex;
    flex-direction: column;
    @include mobile {
        padding: 20px;
    }
    .contact-top {
        width: 50%;
        padding: 0 0 0 200px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        @include mobile {
            padding: 0;
            width: 100%;
            text-align: center;
            justify-content: center;
            align-items: center;
        }
        .top-span1 {
            font-size: 34px;
            margin: 0 0 20px 0;
            @include mobile {
                text-align: center;
            }
        }
        .top-span2 {
            font-size: 20px;
            margin: 0 0 15px 0;
        }
    }
    .contact-section {
        margin: 50px 200px 0 200px;
        width: calc(100% - 400px);
        height: auto;
        display: flex;
        @include mobile {
            width: 100%;
            margin: 0;
            flex-direction: column;
        }
        .contact-form {
            width: 60%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 50px 100px 50px 100px;
            @include mobile {
                width: 100%;
                padding: 20px;
            }
            .form-span1 {
                font-size: 24px;
                text-align: left;
                padding: 0 0 20px 0;
            }
            .form-btn {
                @include mobile {
                    width: 100vw;
                }
            }
        }
        .contact-info {
            width: 40%;
            background-color: #10424b;
            height: auto;
            border-radius: 0;
            color: white;
            display: flex;
            flex-direction: column;
            text-align: left;
            @include mobile {
                width: 100%;
            }
            .info-span1 {
                font-size: 24px;
                margin: 50px 0 50px 0;
                @include mobile {
                    margin: 30px 0;
                }
            }
            .sections {
                display: flex;
                flex-direction: column;
            }
            .section {
                padding: 0 0 40px 0;
                font-size: 18px;
                display: flex;
                @include mobile {
                    padding: 0 20px 40px 20px;
                }
                .right-icon {
                    font-size: 30px;
                    padding: 0 20px 0 0;
                }
                a {
                    color: white;
                    text-decoration: none;
                    display: block;
                    position: relative;
                    overflow: hidden;
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 0.1em;
                        background-color: white;
                        opacity: 0;
                        transition: opacity 300ms, transform 300ms;
                        opacity: 1;
                        transform: translate3d(-100%, 0, 0);
                    }
                
                    &:hover::after,
                    &:focus::after {
                        opacity: 1;
                        transform: translate3d(0, 0.2em, 0);
                        transform: translate3d(0, 0, 0);
                    }
                }
            }
        }
    }
}
.v-card> :last-child:not(.v-btn):not(.v-chip):not(.v-avatar) {
    border-bottom-left-radius: 0;
    border-top-right-radius: 3px;
}
</style>